// extracted by mini-css-extract-plugin
export default {"filterContainer":"ResponsesComponent__filterContainer___MHCRp","emptyTextContainer":"ResponsesComponent__emptyTextContainer___iHEFb"};